var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"input_dropdown",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20","fill":"transparent"}},[_c('path',{attrs:{"d":"M15 7.5L10 12.5L5 7.5","stroke":_vm.color || '#000',"stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }